module.exports = __webpack_public_path__ + "static/media/course_01.e04b118d.png";